import AnalyticsService from '@/integrations/analytics/AnalyticsService';
import { AuthRoute } from '/@/modules/auth/routes/auth.routes';
import AuthService from '/@/modules/auth/services/AuthService';
import ToastService from '/@/modules/core/ui/services/ToastService';
import Lang from '/@/modules/core/app/services/Lang';

export const AuthUserLogOutMixin = {
  methods: {
    async logout() {
      AnalyticsService.reset();
      await this.$router.push({ name: AuthRoute.LOGIN.name });
      await AuthService.logout(async () => {});
      ToastService.show(Lang.t('auth.you-have-successfully'));
    }
  }
};
